import React from "react";
import AboutWelcome from "./AboutWelcome/AboutWelcome";
import Founder from "./Founder/Founder";
import OurStory from "./OurStory/OurStory";
import OurJourney from "./OurJourney/OurJourney";
import OurTeam from "./OurTeam/OurTeam";
import Awards from "./Awards/Awards";
import Quotes from "./../Home/Testimonials/Quotes";
import VisionValues from "./VisionValues/VisionValues";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import TrackApi from "../Activity_Track/TrackApi";
function About() {
  const [cookies, setCookie] = useCookies(['LeadId']);

  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "about page visit",
      "mx_Custom_1": "About Us",
      "mx_Custom_2": "Your about Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  })
  return (
    <>
      <AboutWelcome />
      <Founder />
      <VisionValues />
      <OurStory />
      <OurJourney />
      {/* <Quotes /> */}
      {/* <OurTeam />
      <Awards /> */}
    </>
  );
}
export default About;
